import { Tooltip } from 'antd';
import CompareIcon from 'assets/svg/CompareIcon';
import { colorConstants } from 'config/colorConstants';
import React, { FC } from 'react';
import { calculateFontSize } from 'utils/helperMethods';

interface Props {
    active: boolean;
    disabled: boolean;
    onClick: (index: number, active: boolean) => void;
    index: number;
}
const cellSize = calculateFontSize(window.innerWidth, 18);

const SubFilterCompareIcon: FC<Props> = ({ active, onClick, index, disabled }) => {
    return (
        <Tooltip placement="bottom" title={disabled ? null : 'Compare'}>
            <div
                aria-disabled={disabled}
                onClick={() => {
                    if (disabled) return;
                    onClick(index, active);
                }}
                style={{ width: cellSize, height: cellSize }}
                className={`flex justify-center items-center rounded ${
                    active ? 'bg-purpleFont' : 'bg-white border-borderLinePurpuleAlt border'
                } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} `}
            >
                <CompareIcon stroke={active ? 'white' : colorConstants.violet} />
            </div>
        </Tooltip>
    );
};

export default SubFilterCompareIcon;
